export const TEXT_KIT_ACTIVATION = 'Kit Activation'
